<template>
  <div class="index">
    <div class="index-con">
      <!-- <img class="index-img" src="@/assets/images/new-018.jpg" alt="" /> -->
      <div class="router">
        <span>IRADSTM</span> <b>→</b> <span>News & Events</span> <b>→</b>
        <span>Upcoming Events</span>
      </div>
      <div class="title">Upcoming Events</div>
      <div class="box-more">
        <div class="box-more-all" @click="toDetail(item.news_id)" v-for="(item, index) in newslist" :key="index">
          <div class="box-more-all-img">
            <img :src="item.image_url" alt="" />
          </div>
          <div>
            <div class="box-more-all-title">{{ item.news_title_en }}</div>
            <div class="box-sendtime"> {{ item.source_en }}</div>
            <div class="more">Read more</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newslist: [],
      news_id: '',
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    toDetail(news_id) {
      this.$router.push({ path: '/events-content?news_id=' + news_id });
    },
    getNewsList() {
      this.$http.news_list
        ({
          page: this.page,
          pagesize: 20,
          type_id: 836,

        })
        .then((res) => {
          this.newslist = res.data;
        });
    }
  },
};
</script>

<style lang="less" scoped>
.box-more {
  margin: 50px 20px 20px 100px;
  cursor: pointer;
}

.box-more-all {
  display: flex;
  flex-direction: row;
  margin: 20px 0;

  .box-more-all-img {
    width: 200px;
    height: 150px;

    img {
      width: 90%;
      height: 90%;
      object-fit: contain;
    }
  }

  .box-sendtime {
    font-size: 16px;
    color: rgba(153, 153, 153, 0.87);
    margin-left: 10px;
    padding-bottom: 1px;
  }

  .box-more-all-title {
    //color: #5b965a;
    font-weight: 600;
    font-size: 18px;
    margin: 10px 100px 10px 10px;
  }
}

.swiper,
.swiper-item {
  height: 270px;
}

.swiper-item {
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}

.swiper-item-img {
  width: 100%;
  height: auto;
}

.more {
  margin-top: 8px;
  margin-left: 10px;
  display: inline-block;
  padding: 10px;
  background: #5b965a;
  transition: background-color 0.3s;
  color: #fff;
  font-family: Canaro, Arial, sans-serif;
  font-size: 16px;
  line-height: 14px;
  font-weight: 700;
  text-align: center;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;

  .small-title {
    margin: 25px 0;
    font-weight: 600;
  }

  .card {
    padding: 25px 15px;
    box-sizing: border-box;
    position: relative;
    font-weight: 700;
    line-height: 1.9;
    background-color: hsla(0, 0%, 50.2%, 0.05);

    .card-title {
      color: #5b965a;
      margin-bottom: 20px;
    }

    img {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }

    .right {
      position: absolute;
      bottom: 30px;
      right: 35px;
      width: 35%;
      height: auto;
    }
  }

  .box {
    padding: 0 100px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .text {
    font-size: 16px;
    line-height: 2;
  }

  .text-green {
    color: #5b965a;
  }

  .title {
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .box-title {
    text-align: center;
    position: relative;
    padding-bottom: 10px;
    color: #5b965a;
    margin-bottom: 50px;
    font-family: Canaro, Arial, sans-serif;
    font-size: 30px;
    line-height: 1.9;
    font-weight: 700;
    margin-bottom: 30px;
    width: 100%;
    margin-top: 50px;

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 600px;
      max-width: 100%;
      height: 6px;
      background-color: #5b965a;
    }
  }

  .router {
    display: flex;
    margin: 23px 0 31px;
    align-items: center;

    span {
      color: rgba(31, 31, 31, 0.5);
      font-family: Canaro, Arial, sans-serif;
      font-size: 11px;
      line-height: 1.8;
      font-weight: 400;
      white-space: nowrap;
      cursor: pointer;
    }

    b {
      color: #f9b033;
      font-weight: 400;
      margin: 0 10px;
    }

    span:nth-last-of-type(1) {
      color: #333;
    }
  }

  .index-img {
    width: 100%;
    height: auto;
  }
}
@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
    }
  }

  .box-more {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  .box-more-all {
    display: block;
    background-color: #f0f0f0;
    padding: 10px;
    box-sizing: border-box;

    .box-more-all-img {
      width: 100%;
      height: auto;
    }

    .box-more-all-title {
      margin: 5px 0;
    }

    .box-sendtime {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConferenceEvents.vue